import MarketingLanding from "../components/marketing/MarketingLanding";
import particulares from "../content/particulares";
import SEO from "../components/SEO";

const HERO_IMAGE =
  "https://images.unsplash.com/photo-1738168273959-952fdc961991?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjBhcGFydG1lbnQlMjBpbnRlcmlvciUyMGxpdmluZyUyMHJvb218ZW58MHx8fHwxNzc1NTA3Mjg4fDA&ixlib=rb-4.1.0&q=85";

const ParticularesPage = () => {
  const content = particulares.es;

  return (
    <>
      <SEO page="particulares" />
      <MarketingLanding
        content={content}
        heroImage={HERO_IMAGE}
        showLangSwitcher={false}
      />
    </>
  );
};

export default ParticularesPage;
